import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function HowItWorksModal({ onClose }) {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  const SLIDES = [
    { id: 'bienvenida', emoji: '⚽', title: t('hiw_s1_title'), subtitle: t('hiw_s1_sub'), desc: t('hiw_s1_desc'), color: '#F0B429', items: null },
    { id: 'participante', emoji: '🎯', title: t('hiw_s2_title'), subtitle: t('hiw_s2_sub'), desc: t('hiw_s2_desc'), color: '#06B86A',
      items: [{ icon: '📲', text: t('hiw_s2_i1') }, { icon: '📝', text: t('hiw_s2_i2') }, { icon: '⚽', text: t('hiw_s2_i3') }, { icon: '🏆', text: t('hiw_s2_i4') }] },
    { id: 'puntos', emoji: '🥇', title: t('hiw_s3_title'), subtitle: t('hiw_s3_sub'), desc: t('hiw_s3_desc'), color: '#F0B429',
      items: [{ icon: '🎯', text: t('hiw_s3_i1') }, { icon: '✅', text: t('hiw_s3_i2') }, { icon: '👍', text: t('hiw_s3_i3') }, { icon: '❌', text: t('hiw_s3_i4') }] },
    { id: 'especiales', emoji: '🌟', title: t('hiw_s4_title'), subtitle: t('hiw_s4_sub'), desc: t('hiw_s4_desc'), color: '#A78BFA',
      items: [{ icon: '🏆', text: t('hiw_s4_i1') }, { icon: '👟', text: t('hiw_s4_i2') }, { icon: '🗺️', text: t('hiw_s4_i3') }, { icon: '🔒', text: t('hiw_s4_i4') }] },
    { id: 'admin', emoji: '👑', title: t('hiw_s5_title'), subtitle: t('hiw_s5_sub'), desc: t('hiw_s5_desc'), color: '#F0B429',
      items: [{ icon: '🆕', text: t('hiw_s5_i1') }, { icon: '📨', text: t('hiw_s5_i2') }, { icon: '⚙️', text: t('hiw_s5_i3') }, { icon: '🤖', text: t('hiw_s5_i4') }] },
    { id: 'multigrupo', emoji: '🌎', title: t('hiw_s6_title'), subtitle: t('hiw_s6_sub'), desc: t('hiw_s6_desc'), color: '#06B86A',
      items: [{ icon: '👑', text: t('hiw_s6_i1') }, { icon: '🎮', text: t('hiw_s6_i2') }, { icon: '📱', text: t('hiw_s6_i3') }, { icon: '🏅', text: t('hiw_s6_i4') }] },
    { id: 'planes', emoji: '💎', title: t('hiw_s7_title'), subtitle: t('hiw_s7_sub'), desc: t('hiw_s7_desc'), color: '#F0B429',
      items: [{ icon: '🟡', text: t('hiw_s7_i1') }, { icon: '🟢', text: t('hiw_s7_i2') }, { icon: '🔵', text: t('hiw_s7_i3') }, { icon: '🚀', text: t('hiw_s7_i4') }] },
  ];

  const slide = SLIDES[current];

  function next() {
    if (current < SLIDES.length - 1) setCurrent(c => c + 1);
    else onClose();
  }
  function prev() {
    if (current > 0) setCurrent(c => c - 1);
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 3000,
        background: 'rgba(0,0,0,0.85)',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        @keyframes fadeSlide {
          from { opacity: 0; transform: translateX(18px); }
          to   { opacity: 1; transform: translateX(0); }
        }
        .hiw-item { animation: fadeSlide 0.3s ease both; }
        .hiw-btn-next:active { transform: scale(0.97); }
        .hiw-dot { transition: all 0.25s ease; }
      `}</style>

      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#111118',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '24px 24px 0 0',
          padding: '0 0 calc(env(safe-area-inset-bottom) + 24px)',
          width: '100%', maxWidth: 480,
          animation: 'slideUp 0.35s cubic-bezier(0.32,0.72,0,1)',
          overflow: 'hidden',
        }}
      >
        {/* Barra de progreso */}
        <div style={{ display: 'flex', gap: 4, padding: '16px 20px 0' }}>
          {SLIDES.map((_, i) => (
            <div
              key={i}
              className="hiw-dot"
              onClick={() => setCurrent(i)}
              style={{
                flex: 1, height: 3, borderRadius: 2,
                background: i <= current ? slide.color : 'rgba(255,255,255,0.1)',
                cursor: 'pointer',
              }}
            />
          ))}
        </div>

        {/* Header con X */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 16px 0' }}>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.06)', border: 'none',
            borderRadius: 20, width: 32, height: 32,
            color: '#6B6B7B', fontSize: 16, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>
        </div>

        {/* Contenido del slide */}
        <div key={current} style={{ padding: '16px 24px 24px', animation: 'fadeSlide 0.25s ease' }}>

          {/* Emoji + título */}
          <div style={{ textAlign: 'center', marginBottom: 20 }}>
            <div style={{
              width: 72, height: 72, borderRadius: 20, margin: '0 auto 14px',
              background: `rgba(${slide.color === '#F0B429' ? '240,180,41' : slide.color === '#06B86A' ? '6,184,106' : '167,139,250'},0.12)`,
              border: `1px solid rgba(${slide.color === '#F0B429' ? '240,180,41' : slide.color === '#06B86A' ? '6,184,106' : '167,139,250'},0.25)`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 36,
            }}>
              {slide.emoji}
            </div>
            <div style={{
              fontFamily: "'Oswald',sans-serif",
              fontSize: 22, fontWeight: 700, letterSpacing: 2,
              color: slide.color, marginBottom: 4,
            }}>
              {slide.title}
            </div>
            <div style={{ fontSize: 11, color: '#6B6B7B', letterSpacing: 1 }}>
              {slide.subtitle}
            </div>
          </div>

          {/* Descripción */}
          <div style={{
            fontSize: 13, color: '#aaa', lineHeight: 1.6,
            textAlign: 'center', marginBottom: slide.items ? 18 : 32,
            fontFamily: "'Inter',sans-serif",
          }}>
            {slide.desc}
          </div>

          {/* Items */}
          {slide.items && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
              {slide.items.map((item, i) => (
                <div
                  key={i}
                  className="hiw-item"
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: 12, padding: '11px 14px',
                    animationDelay: `${i * 60}ms`,
                  }}
                >
                  <span style={{ fontSize: 18, flexShrink: 0 }}>{item.icon}</span>
                  <span style={{ fontSize: 13, color: '#ccc', lineHeight: 1.35, fontFamily: "'Inter',sans-serif" }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* Botones navegación */}
          <div style={{ display: 'flex', gap: 10 }}>
            {current > 0 && (
              <button onClick={prev} style={{
                flex: '0 0 auto', padding: '13px 18px',
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: 14, color: '#6B6B7B',
                fontFamily: "'Oswald',sans-serif", fontSize: 14,
                cursor: 'pointer', letterSpacing: 1,
              }}>
              {t('hiw_btn_back')}
              </button>
            )}
            <button
              className="hiw-btn-next"
              onClick={next}
              style={{
                flex: 1, padding: '14px',
                background: `linear-gradient(135deg, ${slide.color}, ${slide.color === '#F0B429' ? '#C9820A' : slide.color === '#06B86A' ? '#059a58' : '#7c5cfc'})`,
                border: 'none', borderRadius: 14,
                fontFamily: "'Oswald',sans-serif", fontSize: 15,
                fontWeight: 700, letterSpacing: 2,
                color: slide.color === '#F0B429' ? '#080810' : '#fff',
                cursor: 'pointer',
              }}
            >
              {current === SLIDES.length - 1 ? t('hiw_btn_done') : t('hiw_btn_next')}
            </button>
          </div>

          {/* Contador */}
          <div style={{ textAlign: 'center', marginTop: 12, fontSize: 11, color: '#333' }}>
            {current + 1} / {SLIDES.length}
          </div>
        </div>
      </div>
    </div>
  );
}